import {COLOR} from "src/service/constant/color";
import {ModalAlertContent, ModalOnlyTitle} from "src/styles/common/modal";
import {ModalBtn} from "src/styles/common/CommonForm/buttonform";

const AlertModal = (props: any) => {
    const {option, ClickFunc} = props
    return (
        <ModalAlertContent>
            <ModalOnlyTitle>{option}</ModalOnlyTitle>
            <ModalBtn bgColor={COLOR.point1} onClick={ClickFunc}>
                <span>확인</span>
            </ModalBtn>
        </ModalAlertContent>
    )
}
export default AlertModal
